import { BREAKPOINTS, transitionAnimation } from 'lib/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { NAVIGATION_WIDTHS } from '../constants';

const StyledSideContentWrapper = styled.div`
  ${transitionAnimation('margin-left')};
  box-sizing: border-box;
  margin-left: ${NAVIGATION_WIDTHS.COLLAPSED};

  @media ${BREAKPOINTS.L} {
    margin-left: ${({ $isNavigationCollapsed }) =>
      $isNavigationCollapsed ? NAVIGATION_WIDTHS.COLLAPSED : NAVIGATION_WIDTHS.EXPANDED};
  }
`;

const SideContentWrapper = ({ isNavigationCollapsed = true, ...other }) => (
  <StyledSideContentWrapper $isNavigationCollapsed={isNavigationCollapsed} {...other} />
);

export { SideContentWrapper };

SideContentWrapper.propTypes = {
  /** If true then the navigation is collapsed */
  isNavigationCollapsed: PropTypes.bool,
};
